import {MediaFamilyType} from '../enum/mediaFamilyType';
import {PaymentSource} from '../enum/paymentSource';
import {Reservation} from '../reservation/reservation';
import {PlugResultDto} from '../infra/plug/plug';
import {ChargeRecordStatus} from '../chargeRecord/chargeRecord';
import {AbstractEventDetailDto} from '../event/event';

export interface OtpSessionRequest {
    chargePointRef?: string;
    chargePointVisualId?: string;
    clientSource?: PaymentSource;
    orientation?: string;
    outletModel?: string;
    reservationDuration?: number;
    stationAlias?: string;
    userEmail?: string;
}

export interface OtpPriceResponse {
    // availablePlugs?: PlugResultDto[];
    // availablePlugsByStationAlias?: { [index: string]: PlugResultDto[] };
    // chargeArea?: ChargeArea;
    chargeAreaName?: string;
    chargeAreaRef?: string;
    chargePricingInfos?: string[];
    currencyUnit?: string;
    distanceInKm?: number;
    expirationDate?: string;
    freeCharge?: boolean;
    price?: number;
    reservationAvailable?: boolean;
    reservationDurations?: number[];
    stationAlias?: string;
    otpType: MediaFamilyType;
}

export interface OtpPriceDto {
    currencyUnit: string;
    otpType: MediaFamilyType;
    otpPriceWithVAT: number;
    reservationPriceWithVAT: number;
    totalPriceWithVAT: number;
    freeCharge: boolean;
}

export interface OTPSession {
    _id?: string;
    alias?: string;
    authorizationRef?: string;
    availablePlugs?: PlugResultDto[];
    chargeAreaName?: string;
    chargePointRef?: string;
    chargePointSupervisedId?: string;
    chargePointVisualId?: string;
    consumptionRef?: string;
    date?: string;
    emoRef?: string;
    error?: OTPSessionError;
    expirationDate?: string;
    freeCharge?: boolean;
    mediaRef?: string;
    otpCode?: string;
    otpExpirationDate?: string;
    otpType?: MediaFamilyType;
    payments?: OTPSessionPayment[];
    phoneNumber?: string;
    plugOrientation?: string;
    plugRef?: string;
    plugType?: string;
    price?: number;
    reservation?: Reservation;
    reservationDuration?: number;
    reservationPrice?: number;
    reservationRef?: string;
    source?: PaymentSource;
    stationRef?: string;
    stationSupervisedId?: string;
    status?: OTPSessionStatus;
    userEmail?: string;
    userRef?: string;
    waitFor?: number;
}

export interface OtpSessionDto extends AbstractEventDetailDto {
    chargeRecordStatus?: ChargeRecordStatus;
    otpExpirationStatus?: OtpExpirationStatus;
    reservationRef?: string;
}

export interface OTPSessionPayment {
    date?: string;
    providerPaymentId?: string;
}

export enum OTPSessionError {
    PRICE_NOT_FOUND = 'PRICE_NOT_FOUND',
    CUSTOMER_ACCOUNT_NOT_FOUND = 'CUSTOMER_ACCOUNT_NOT_FOUND',
    SUBSCRIBER_NOT_FOUND = 'SUBSCRIBER_NOT_FOUND',
    USER_NOT_FOUND = 'USER_NOT_FOUND',
    CHARGE_AREA_CLOSED = 'CHARGE_AREA_CLOSED',
    OTP_CONFIG_NOT_FOUND = 'OTP_CONFIG_NOT_FOUND',
    USAGE_KEY_NOT_FOUND = 'USAGE_KEY_NOT_FOUND',
    STOP_KEY_NOT_FOUND = 'STOP_KEY_NOT_FOUND',
    OTP_WINDOW_NOT_FOUND = 'OTP_WINDOW_NOT_FOUND',
    OTP_ALLOWED_PREVIOUS_WINDOW_NOT_FOUND = 'OTP_ALLOWED_PREVIOUS_WINDOW_NOT_FOUND',
    OTP_ALLOWED_NEXT_WINDOW_NOT_FOUND = 'OTP_ALLOWED_NEXT_WINDOW_NOT_FOUND',
}

export enum OTPSessionStatus {
    OPEN = 'OPEN',
    WAIT_FOR = 'WAIT_FOR',
    TIMEOUT = 'TIMEOUT',
    ENDED = 'ENDED',
    ERROR = 'ERROR',
    WAIT_RESERVATION = 'WAIT_RESERVATION',
    IGNORED_BY_USER = 'IGNORED_BY_USER',
}

export enum OtpExpirationStatus {
    READY_TO_CHARGE = 'READY_TO_CHARGE',
    CHARGING = 'CHARGING',
    EXPIRED = 'EXPIRED'
}

